export enum CookiesFooterEnum {
  COOKIES_FOOTER_TEXT = 'cookies-footer-text',
  COOKIES_FOOTER_BUTTON = 'cookies-footer-button',
}
